export const queryKeys = {
  alerts: ['alerts'] as const,
  allApplications: ['allApplications'] as const,
  applicationDetails: ['applicationDetails'] as const,
  applicationCustomFields: ['applicationCustomFields'] as const,
  backgroundChecks: (path: string) => ['backgroundChecks', path] as const,
  documents: ['documents'] as const,
  forms: ['forms'] as const,
  fraudReport: ['fraudReport'] as const,
  fraudResolvedReasons: ['fraudResolvedReasons'] as const,
  identityVerifications: ['identityVerifications'] as const,
  scheduledIdentityVerification: ['scheduledIdentityVerification'] as const,
  crossCheckVerificationDetails: (verificationId: number) =>
    ['crossCheckVerificationDetails', verificationId] as const,
  notesSummary: ['notesSummary'] as const,
  previousReminders: ['previousReminders'] as const,
  prospectApplications: ['prospectApplications'] as const,
  prospectDetails: ['prospectDetails'] as const,
  reminders: ['reminders'] as const,
  securityScreening: ['securityScreening'] as const,
  sourceAndResponsibility: ['sourceAndResponsibility'] as const,
  stages: ['stages'] as const,
  stageInterviews: (stageId: number) => ['stageInterviews', stageId] as const,
  tasks: ['tasks'] as const,
  notes: ['notes'] as const,
  stagesCallout: ['stagesCallout'] as const,
};

export const mutationKeys = {
  requestIdentityVerification: ['requestIdentityVerification'] as const,
  sendIdentityVerificationReminder: [
    'sendIdentityVerificationReminder',
  ] as const,
  sendNotetakerConsentRequest: ['sendNotetakerConsentRequest'] as const,
};
